module.exports = __webpack_public_path__ + "img/beer_id-25.c8dc5155.png";